import { Controller, type useForm } from 'react-hook-form';
import { Select } from '@/shared/components';
import { clockFromMinutes, type ResourceValues } from './resourceModel';

/** Nimmt `id` und die aria-Angaben von `FormField` an, damit das Label die Auswahl benennt. */
export function MinuteSelect({
  control,
  name,
  options,
  ...aria
}: {
  control: ReturnType<typeof useForm<ResourceValues>>['control'];
  name: 'opensAtMinute' | 'closesAtMinute';
  options: number[];
  id?: string;
  'aria-invalid'?: 'true';
  'aria-describedby'?: string;
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Select
          {...aria}
          value={field.value}
          onChange={(event) => field.onChange(Number(event.target.value))}
          onBlur={field.onBlur}
          ref={field.ref}
        >
          {options.map((minutes) => (
            <option key={minutes} value={minutes}>
              {clockFromMinutes(minutes)}
            </option>
          ))}
        </Select>
      )}
    />
  );
}
